import { render, staticRenderFns } from "./IdentityReportDetailResult.vue?vue&type=template&id=4be7024e&scoped=true"
import script from "./IdentityReportDetailResult.vue?vue&type=script&lang=js"
export * from "./IdentityReportDetailResult.vue?vue&type=script&lang=js"
import style0 from "./IdentityReportDetailResult.vue?vue&type=style&index=0&id=4be7024e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7024e",
  null
  
)

export default component.exports